export default __webpack_public_path__ + "static/media/triple-03.a5431e76.png";